import axiosIns from "@/libs/axios";
import EventBus from "@/custom/eventBus";
import { makeToast } from "@/layouts/components/Popups";
import i18n from '@/libs/i18n'
import { apiCall } from "@/store/AxiosCaller.js" 
import { errorToast, successToast } from "@/custom/class/FunctionClasses/CommonToasts";

export default {
  state: {
    loading: false,
    skeleton: false,
    image:{
      version: 1
    }
  },
  getters: {
    getLoadingState: (state) => {
      return state.loading;
    },
    getSkeletonState: (state) => {
      return state.skeleton
    },
    getImage: (state) => (identifier) =>{
      let url = `${process.env.VUE_APP__API_V2_URL}upload/google/${identifier}`
      url = url + `?v=${state.image.version}` 
      return url
    }
  },
  mutations: {
    SET_LOADING_STATE(state, payload) {
      state.loading = payload;
    },
    SET_SKELETON_STATE(state, payload) {
      state.skeleton = payload;
    },
  },
  actions: {
    setLoadingState({ commit }, payload) {
      if(payload) {
        EventBus.$emit("startLoading");
      } else {
        EventBus.$emit("stopLoading");
      }
      commit("SET_LOADING_STATE", false);
    },
    setSkeletonState({ commit }, payload) {
      commit("SET_SKELETON_STATE", payload);
    },
    saveImage({state}, {identifier, base64}){
      return apiCall({
        url: `/upload/google`,
        method: 'post',
        payload:{
          gbima_string_identifier: identifier,
          gbima_base64: base64
        },
        loadingOnCursor: true,
      })
      .then((resp)=>{
        state.image.version = state.image.version + 1   
      })
      .catch((err)=>{
        console.error(err)
        errorToast({text: "Couldn't update - image too large"})
      })
    },

    
    fetchStatus(_ ) {
      let config = {
        headers: {
          "x-api-url": "/enum/helper/status",
          session: `Session ${localStorage.getItem("sessionKey")}`,
        },
      };
      return new Promise((resolve, reject) => {
       console.trace(); axiosIns
          .get("/", config)
          .then((resp) => {
            if (resp.status == 403){
              makeToast({
                title: i18n.t('common.toast.forbidden.title'),
                text: i18n.t('common.toast.forbidden.message'),
                variant: "danger",
                icon: "SlashIcon",
              })              
            } 
            if (resp.status == 200 && !resp.data.error) {
              resolve(resp.data.data);
            } else {
              throw resp
            }
          })
          .catch((error) => {
            if (error?.response?.status == 403){
              makeToast({
                title: i18n.t('common.toast.forbidden.title'),
                text: i18n.t('common.toast.forbidden.message'),
                variant: "danger",
                icon: "SlashIcon",
              })
            }
            reject(error);
          });
      });
    },
    resolveUrl(_, data) {
			let params = {
				...data.params,
			}

			let url = data.url;
			let has_params = false;

			Object.keys(params).forEach((key) => {
				if(params[key] !== null) {
					if(has_params) {
						url += "&";
					} else {
						url += "?";
					}
					

					params[key] ? url += `${key}=${params[key]}` : '';

					has_params = true;
				}
			});

      url = url.replaceAll('\t', '')

      return url;
    },
    fetchActiveStatus(_ ){
      let data = []
      data['items'] = [
        {
          label: 'Active',
          value: true,
        },
        { 
          label: 'Inactive',
          value: false,
        }
      ]

      return data
    },
    fetchUserSearchBy(_){
      let data = []
      data['items'] = [
        {
          text: 'Fullname',
          value: 'Fullname',
        },
        { 
          text: 'Username',
          value: 'Username',
        }
      ]

      return data
    },
    fetchUserSearchType(_){
      let data = []
      data['items'] = [
        {
          text: 'IP Whitelist',
          value: 'ip_whitelist',
        },
        { 
          text: 'Active Sessions',
          value: 'session',
        }
      ]

      return data
    },
    startLoading() {
      EventBus.$emit("startLoading");
    },
    stopLoading() {
      EventBus.$emit("stopLoading");
    },
    customNameGenerator({ dispatch }) {
      let config = {
        headers: { }
      }
      
      return new Promise((resolve, reject) => {
        var name_type = Math.random() * 2 | 0;

        let names;

        switch (name_type) {
          case 0: {
            var nm1 = ["The Accidental", "The Ancient", "The Aqua", "The Awesome", "The Black", "The Blue", "The Brass", "The Brave", "The Broad", "The Broken", "The Bronze", "The Calm", "The Clever", "The Cold", "The Colossal", "The Confident", "The Cool", "The Copper", "The Crimson", "The Dapper", "The Dark", "The Defiant", "The Dramatic", "The Eager", "The Earth", "The Earthen", "The Electric", "The Electron", "The Elegant", "The Ethereal", "The Fabulous", "The Famous", "The Fancy", "The Fantastic", "The Fast", "The Fearless", "The Fiery", "The Fire", "The Galactic", "The Gentle", "The Giant", "The Gigantic", "The Glorious", "The Godly", "The Golden", "The Good", "The Gorgeous", "The Gray", "The Green", "The Heavenly", "The Heavy", "The Honorable", "The Hot", "The Huge", "The Hypnotic", "The Ice", "The Impossible", "The Incredible", "The Infamous", "The Intelligent", "The Iron", "The Jade", "The Jolly", "The Kind", "The Light", "The Long", "The Lucky", "The Macho", "The Magical", "The Magnificent", "The Majestic", "The Mammoth", "The Marked", "The Marvelous", "The Merciful", "The Mighty", "The Misty", "The Mysterious", "The Nifty", "The Nimble", "The Nuclear", "The Old", "The Orange", "The Outrageous", "The Pink", "The Proud", "The Purple", "The Quantum", "The Quick", "The Quiet", "The Rapid", "The Red", "The Righteous", "The Royal", "The Scarlet", "The Silver", "The Smooth", "The Spectacular", "The Steel", "The Storm", "The Swift", "The Terrific", "The Thunder", "The Vengeful", "The Voiceless", "The Wacky", "The Water", "The Whispering", "The White", "The Wise", "The Yellow"];
            var nm2 = ["Robin", "Owl", "Vulture", "Condor", "Falcon", "Merlin", "Eagle", "Hawk", "Swan", "Ibis", "Crane", "Snipe", "Macaw", "Amazon", "Nighthawk", "Nightowl", "Monarch", "Lord", "Crow", "Raven", "Swallow", "Starling", "Sparrow", "Ant", "Antman", "Wasp", "Phoenix", "Waspman", "Grasshopper", "Cricket", "Beetle", "Assassin", "Mantis", "Mothman", "Moth", "Termite", "Dragonfly", "Elephantman", "Wolf", "Wolfman", "Bat", "Rhino", "Rhinoceros", "Cat", "Catman", "Lynx", "Gorilla", "Leopard", "Armadillo", "Bear", "Tiger", "Lion", "Fox", "Raccoon", "Ox", "Oxman", "Puma", "Panther", "Wolverine", "Cheetah", "Mongoose", "Jackal", "Hornet", "Warrior", "Fighter", "Angel", "Devil", "Guardian", "Protector", "Champion", "Defender", "Saviour", "Guard", "Watcher", "Slayer", "Killer", "Soldier", "Marksman", "Sniper", "Commando", "Gunner", "Mercenary", "Scout", "Veteran", "Sentinel", "Shepherd", "Warden", "Keeper", "Watchman", "Magician", "Charmer", "Conjurer", "Enchanter", "Genius", "Illusionist", "Prophet", "Seer", "Shaman", "Siren", "Wizard", "Mage", "Master", "Mastermind", "Prodigy", "Sage", "Wonder", "Wonderman", "Whiz", "Spectacle", "Duke", "Baron", "Prince", "Shield", "Sword", "Dagger", "Trident", "Knuckles", "Daggers", "Swordsman", "Scimitar", "Katana", "Axeman", "Scepter", "Hammer", "Gladiator", "Shadow", "Shade", "Gloom", "Spy", "Agent", "Detective", "Mole", "Leader", "Vindicator", "Captain", "Chief", "Doctor", "General", "Smasher", "Spirit", "Scorpion", "Spider"];
            var nm3 = ["Doctor", "Captain", "Doctor", "Captain", "Lord", "Professor", "Professor", "Mister", "Commander", "Master", "Agent", "Master", "Agent", "Chief", "Warden", "", "", "", "", "", "", "", "", "", "", ""];
            var nm4 = ["Red", "Blue", "Green", "Yellow", "Purple", "Pink", "Gray", "Dark", "Light", "Orange", "Galactic", "Black", "White", "Clever", "Famous", "Infamous", "Brave", "Calm", "Gentle", "Proud", "Dapper", "Eager", "Jolly", "Broad", "Brass", "Copper", "Golden", "Silver", "Bronze", "Iron", "Steel", "Huge", "Mammoth", "Gigantic", "Colossal", "Quiet", "Thundering", "Whispering", "Ancient", "Fast", "Fancy", "Magnificent", "Mysterious", "Old", "Long", "Rapid", "Swift", "Quick", "Broken", "Cold", "Cool", "Hot", "Heavy", "Light", "Good", "Eager", "Fiery", "Elegent", "Electric", "Defiant", "Brave", "Accidental", "Ethereal", "Dramatic", "Awesome", "Impossible", "Incredible", "Intelligent", "Heavenly", "Honorable", "Huge", "Hypnotic", "Gentle", "Giant", "Glorious", "Godly", "Gorgeous", "Fabulous", "Fancy", "Fantastic", "Fearless", "Kind", "Lucky", "Macho", "Magical", "Majestic", "Marked", "Marvelous", "Mighty", "Messy", "Merciful", "Misty", "Nifty", "Nimble", "Outrageous", "Confident", "Rapid", "Righteous", "Royal", "Terrific", "Smooth", "Spectacular", "Wacky", "Wise", "Vengeful", "Voiceless", "Unarmed", "Armed", "Nuclear", "Scarlet", "Quantum", "Electron", "Crimson", "Fire", "Ice", "Earth", "Earthen", "Water", "Aqua", "Storm", "Thunder"];
            var nm5 = ["Masquerade", "Robin", "Owl", "Vulture", "Condor", "Falcon", "Merlin", "Eagle", "Hawk", "Swan", "Ibis", "Phoenix", "Crane", "Snipe", "Macaw", "Amazon", "Nighthawk", "Nightowl", "Monarch", "Lord", "Crow", "Raven", "Swallow", "Starling", "Sparrow", "Ant", "Antman", "Wasp", "Waspman", "Grasshopper", "Cricket", "Beetle", "Assassin", "Mantis", "Mothman", "Moth", "Termite", "Dragonfly", "Elephantman", "Wolf", "Wolfman", "Bat", "Rhino", "Rhinoceros", "Cat", "Catman", "Lynx", "Gorilla", "Leopard", "Armadillo", "Bear", "Tiger", "Lion", "Fox", "Raccoon", "Ox", "Oxman", "Puma", "Panther", "Wolverine", "Cheetah", "Mongoose", "Jackal", "Hornet", "Warrior", "Fighter", "Angel", "Devil", "Guardian", "Protector", "Champion", "Defender", "Saviour", "Watcher", "Slayer", "Killer", "Sentinel", "Shepherd", "Magician", "Charmer", "Conjurer", "Enchanter", "Genius", "Illusionist", "Prophet", "Mastermind", "Prodigy", "Sage", "Wonder", "Spectacle", "Shield", "Sword", "Dagger", "Trident", "Knuckles", "Daggers", "Swordsman", "Scimitar", "Katana", "Axeman", "Scepter", "Hammer", "Shadow", "Shade", "Gloom", "Mole", "Smasher", "Spirit", "Scorpion", "Spider"];
            var nm6 = ["Jaquesson, the Dreamer","Pines, the Only","Talias, The Chosen", "Duhdze, the newly arrived","Doctor Poncius","Geffinho","Apenas, a Rat","Math'SO","Aleafary, the ballerina","Optimo","End-Ray","Bue-Bue","Black Wing","Liquid Steel", "Frost", "Golden Hope", "Hope", "Elemental", "Impossible Girl", "Griffin", "Tecton", "Captain Atomic", "Titanio", "Solar Flare", "Alley Cat", "Snow Storm", "Absolute Zero", "The Great Defender", "Timeline", "Skylar Storm", "Talias, The Chosen", "Remix", "Citadel", "Alpha Dog", "Brain Matter", "Dark Warrior", "The Crusher", "Owl", "Incognito", "Gray Granite", "Gamma", "Spark Plug", "Silver Shield", "Quiver", "Smoke", "Captain Quake", "Icicle", "Metanite", "Blaze", "Fantasia", "Phantasm", "Sparks", "Ace", "Amethyst Heart", "Animalia", "Armed", "Black Bat", "Black Cat", "Black Knight", "Black Phoenix", "Black Star", "Blitzfire", "Boler", "Bolt", "Brass Bison", "Bright Shadow", "Broken Watchman", "Choicemaker", "Cleanser", "Crazy Eight", "Creature", "Criss Cross", "Dark Flame", "Dark Omen", "Dark Titan", "Dazzler", "Deadnite", "Death Roach", "Doctor Chronos", "Doctor Dynasty", "Doctor Juggernaut", "Doctor Titanium", "Dragon Boy", "Dragon Spectre", "Dragonloom", "Dragontooth", "Electric Arrow", "Eltrocus", "Ethereal Phoenix", "Ethereal Titan", "Fallen Pheonix", "Fiery Falcon", "Firebird", "Freefall", "Frozenstar", "Galactic Gargoyle", "Gecko", "Griffin", "Heavy Step", "Helon", "Heloth", "Hopewing", "Ice Raven", "Iron Archer", "Iron Assassin", "Jade Stranger", "King Scorp", "Mad Manta", "Makeshift", "Marked Stranger", "Master Defiance", "Mighty Mamba", "Mister Penance", "Mister X", "Mister Y", "Misty Manta", "Moon Halo", "Moonshadow", "Nightbolt", "Nightleaf", "Nightquake", "Nightwave", "Orothos", "Osa", "Peacebringer", "Phantom", "Phantom Archer", "Phantom Kid", "Phantom Spectre", "Phoen-X", "Quantum Colossus", "Quantum Commander", "Razor", "Red Heart", "Rosethorn", "Saber", "Saberleaf", "Sage", "Savior", "Scarlet Feathers", "Scarlet Horse", "Scarlet King", "Scarlet Sentinel", "Shaden", "Shadow", "Shadowleaf", "Shadowstar", "Silver Goliath", "Silver Shepherd", "Silver Wolf", "Snow Raven", "Spitfire", "Spur", "Star Sentinel", "Starbright", "Stareye", "Starlight", "Starry Night", "Sunspot", "Switcher", "The Hunter", "The Last One", "Thornhead", "Thunder Hawk", "Thunderclap", "Thundering Whisper", "Venom", "Venombite", "Voiceless Stranger", "Wi-Fire", "Wild Tornado", "Wildfire", "Wildflame", "Karma"]
            
            for (var i = 0; i < 10; i++) {
              if (i < 4) {
                let rnd = Math.floor(Math.random() * nm1.length);
                let rnd2 = Math.floor(Math.random() * nm2.length);
                names = nm1[rnd] + " " + nm2[rnd2];
              } else if (i < 8) {
                let rnd = Math.floor(Math.random() * nm3.length);
                let rnd2 = Math.floor(Math.random() * nm4.length);
                let rnd3 = Math.floor(Math.random() * nm5.length);
                names = nm3[rnd] + " " + nm4[rnd2] + " " + nm5[rnd3];
              } else {
                let rnd = Math.floor(Math.random() * nm6.length);
                names = nm6[rnd];
              }
            }
          } break;
          case 1: {
            var nm1 = ["", "", "", "", "b", "br", "c", "ch", "d", "fr", "g", "gr", "j", "k", "m", "n", "p", "q", "r", "t", "x", "z"];
            var nm2 = ["u", "u", "u", "u", "u", "a", "e", "i", "o", "y", "a", "e", "i", "o", "y", "a", "e", "i", "o", "y", "a", "e", "i", "o", "y", "a", "e", "i", "o", "y", "a", "e", "i", "o", "y", "a", "e", "i", "o", "y", "ai", "ay", "ei", "eo", "ia", "ie", "oi"];
            var nm3 = ["d", "ddr", "dr", "g", "gh", "k", "lb", "ldr", "lr", "lzr", "m", "mb", "mm", "mr", "n", "nd", "ndr", "nn", "r", "rd", "rg", "rr", "rs", "rv", "s", "t", "th", "v", "vr", "z", "zz"];
            var nm4 = ["cr", "d", "n", "nt", "r", "rr", "sd"];
            var nm5 = ["", "", "d", "g", "m", "n", "nth", "r", "rth", "s", "ss", "t"];
            var nm6 = ["", "", "", "", "", "", "b", "c", "ch", "d", "f", "fr", "g", "h", "l", "m", "n", "p", "q", "r", "s", "sh", "t", "v", "z"];
            var nm7 = ["u", "u", "u", "u", "a", "e", "i", "o", "y", "a", "e", "i", "o", "y", "a", "e", "i", "o", "y", "a", "e", "i", "o", "y", "a", "e", "i", "o", "y", "a", "e", "i", "o", "y", "a", "e", "i", "o", "y", "a", "e", "i", "o", "y", "a", "e", "i", "o", "y", "ae", "ai", "ay", "ei", "eo", "ie", "io", "oa"];
            var nm8 = ["d", "dh", "g", "gh", "k", "ldr", "ll", "m", "mm", "mr", "n", "nd", "ndr", "nn", "p", "ph", "r", "rg", "rl", "rm", "rr", "rs", "rv", "s", "ss", "t", "th", "v", "vn", "z", "zz"];
            var nm9 = ["d", "l", "n", "nt", "ph", "r", "rr", "ss"];
            var nm10 = ["", "", "", "", "", "l", "lth", "n", "nth", "r", "rth", "s", "ss", "t", "th"];
            var nm11 = ["", "", "", "", "b", "c", "ch", "d", "fr", "g", "m", "n", "p", "q", "r", "s", "t", "v", "x", "z"];
            var nm12 = ["u", "u", "u", "u", "a", "e", "i", "o", "y", "ae", "ai", "ay", "ei", "eo", "ia", "ie", "io", "oa", "oi"];
            var nm13 = ["d", "dh", "dr", "g", "gh", "k", "l", "ldr", "ll", "lr", "m", "mm", "mr", "n", "nd", "ndr", "nn", "p", "ph", "r", "rl", "rm", "rr", "rs", "rv", "s", "ss", "t", "th", "v", "vn", "vr", "z", "zz"];
            var nm14 = ["d", "l", "n", "nt", "ph", "r", "rr", "ss"];
            var nm15 = ["", "", "", "d", "g", "l", "lth", "n", "nth", "r", "rth", "s", "ss", "t", "th"];
            var nm16 = ['the Nocturnal', 'the Protective', 'the Clever', 'the Bright', 'the Dark', 'the Dark One', 'the Dark', 'the Eternal', 'the Firestarter', 'the Eternal One', 'the Calm', 'the Gentle', 'the Redeemer', 'the Champion', 'the Evil One', 'the Chosen', 'the Great', 'the Kind', 'the Fierce', 'the Strong', 'the Tyrant', 'the Dragonlord', 'the Warrior', 'the Barbarian', 'the Tall', 'the Magnificent', 'the Clean', 'the Adorable', 'the Gifted', 'the Tender', 'the Powerful One', 'the Gifted One', 'the Powerful', 'the Black', 'the White', 'the White One', 'the Careful', 'the Clumsy One', 'the Grumpy', 'the Jealous One', 'the Mysterious', 'the Mysterious One', 'the Scary', 'the Scary One', 'the Brave', 'the Victorious', 'the Skinny One', 'the Mammoth', 'the Puny', 'the Quiet', 'the Voiceless', 'the Loud', 'the Voiceless One', 'the Fast One', 'the Swift', 'the Young One', 'the Youngling', 'the Slow', 'the Creep', 'the Warm', 'Warmheart', 'Braveheart', 'Gentleheart', 'the Strong Minded', 'the Stubborn', 'Firebreath', 'Icebreath', 'the Squeeler', 'Champion of Dragons', 'Eternal Fire', 'Gentle Mind', 'Longtail', 'Redeemer of Men', 'Protector of the Weak', 'Protector of the Forest', 'Protector of the Sky', 'Lord of the Skies', 'Champion of the Skies', 'Champion of Men', 'Lord of Fire', 'Lord of Ice', 'Lord of the Red', 'Lord of the Black', 'Lord of the White', 'Lord of the Blue', 'Lord of the Green', 'Lord of the Yellow', 'Lord of the Brown', 'Champion of the Red', 'Champion of the White', 'Champion of the Black', 'Champion of the Blue', 'Champion of the Yellow', 'Champion of the Brown', 'Champion of the Green', 'Protector of Creatures', 'Protector of Life', 'Giver of Life', 'Bringer of Death', 'the Deathlord', 'the Dead', 'Destroyer of Life', 'Destroyer of Men', 'Eater of Sheep', 'Eater of All', 'the Hungry', 'Eater of Bunnies', 'the Bunny Killer', 'the Rabbit Slayer', 'the Taker of Life', 'the Insane', 'the Life Giver'];
            var nm17 = ['the Nocturnal', 'the Protective', 'the Clever', 'the Bright', 'the Dark', 'the Dark One', 'the Dark', 'the Eternal', 'the Firestarter', 'the Eternal One', 'the Calm', 'the Gentle', 'the Redeemer', 'the Champion', 'the Evil One', 'the Chosen', 'the Great', 'the Kind', 'the Fierce', 'the Strong', 'the Dragonlady', 'the Warrior', 'the Barbarian', 'the Tall', 'the Magnificent', 'the Clean', 'the Adorable', 'the Gifted', 'the Tender', 'the Powerful One', 'the Gifted One', 'the Powerful', 'the Black', 'the White', 'the White One', 'the Careful', 'the Clumsy One', 'the Grumpy', 'the Jealous One', 'the Mysterious', 'the Mysterious One', 'the Scary', 'the Scary One', 'the Brave', 'the Victorious', 'the Skinny One', 'the Mammoth', 'the Puny', 'the Quiet', 'the Voiceless', 'the Loud', 'the Voiceless One', 'the Fast One', 'the Swift', 'the Young One', 'the Youngling', 'the Slow', 'the Creep', 'the Warm', 'Warmheart', 'Braveheart', 'Gentleheart', 'the Strong Minded', 'the Stubborn', 'Firebreath', 'Icebreath', 'the Squeeler', 'Champion of Dragons', 'Eternal Fire', 'Gentle Mind', 'Longtail', 'Redeemer of Men', 'Protector of the Weak', 'Protector of the Forest', 'Protector of the Sky', 'Lady of the Skies', 'Champion of the Skies', 'Champion of Men', 'Lady of Fire', 'Lady of Ice', 'Lady of the Red', 'Lady of the Black', 'Lady of the White', 'Lady of the Blue', 'Lady of the Green', 'Lady of the Yellow', 'Lady of the Brown', 'Champion of the Red', 'Champion of the White', 'Champion of the Black', 'Champion of the Blue', 'Champion of the Yellow', 'Champion of the Brown', 'Champion of the Green', 'Protector of Creatures', 'Protector of Life', 'Giver of Life', 'Bringer of Death', 'the Deathlady', 'the Dead', 'Destroyer of Life', 'Destroyer of Men', 'Eater of Sheep', 'Eater of All', 'the Hungry', 'Eater of Bunnies', 'the Bunny Killer', 'the Rabbit Slayer', 'the Taker of Life', 'the Insane', 'the Life Giver'];

            var tp = Math.random() * 3 | 1;

            for (i = 0; i < 10; i++) {
              if (tp === 1) {
                let rnd16 = Math.random() * nm17.length | 0;
                let rnd = Math.random() * nm6.length | 0;
                let rnd2 = Math.random() * nm7.length | 0;
                let rnd3 = Math.random() * nm8.length | 0;
                let rnd4 = Math.random() * nm7.length | 0;
                let rnd5 = Math.random() * nm10.length | 0;
                
                while (nm6[rnd] === nm8[rnd3]) {
                  rnd3 = Math.random() * nm8.length | 0;
                }
                while (nm10[rnd5] === nm8[rnd3]) {
                  rnd5 = Math.random() * nm10.length | 0;
                }
                if (i < 7) {
                    names = nm6[rnd] + nm7[rnd2] + nm8[rnd3] + nm7[rnd4] + nm10[rnd5] + ", " + nm17[rnd16];
                } else {
                  let rnd6 = Math.random() * nm9.length | 0;
                  let rnd7 = Math.random() * nm7.length | 0;
                  while (nm9[rnd6] === nm8[rnd3]) {
                      rnd6 = Math.random() * nm9.length | 0;
                  }
                  names = nm6[rnd] + nm7[rnd2] + nm8[rnd3] + nm7[rnd4] + nm9[rnd6] + nm7[rnd7] + nm10[rnd5] + ", " + nm17[rnd16];
                }
              } else if (tp === 2) {
                let rnd16 = Math.random() * nm16.length | 0;
                let rnd = Math.random() * nm11.length | 0;
                let rnd2 = Math.random() * nm12.length | 0;
                let rnd3 = Math.random() * nm13.length | 0;
                let rnd4 = Math.random() * nm12.length | 0;
                let rnd5 = Math.random() * nm15.length | 0;
                while (nm11[rnd] === nm13[rnd3]) {
                  rnd3 = Math.random() * nm13.length | 0;
                }
                while (nm15[rnd5] === nm13[rnd3]) {
                  rnd5 = Math.random() * nm15.length | 0;
                }
                if (i < 7) {
                  names = nm11[rnd] + nm12[rnd2] + nm13[rnd3] + nm12[rnd4] + nm15[rnd5] + ", " + nm16[rnd16];
                } else {
                  let rnd6 = Math.random() * nm14.length | 0;
                  let rnd7 = Math.random() * nm12.length | 0;
                  while (nm14[rnd6] === nm13[rnd3]) {
                      rnd6 = Math.random() * nm14.length | 0;
                  }
                  names = nm11[rnd] + nm12[rnd2] + nm13[rnd3] + nm12[rnd4] + nm14[rnd6] + nm12[rnd7] + nm15[rnd5] + ", " + nm16[rnd16];
                }
              } else {
                let rnd16 = Math.random() * nm16.length | 0;
                let rnd = Math.random() * nm1.length | 0;
                let rnd2 = Math.random() * nm2.length | 0;
                let rnd3 = Math.random() * nm3.length | 0;
                let rnd4 = Math.random() * nm2.length | 0;
                let rnd5 = Math.random() * nm5.length | 0;
                while (nm1[rnd] === nm3[rnd3]) {
                  rnd3 = Math.random() * nm3.length | 0;
                }
                while (nm5[rnd5] === nm3[rnd3]) {
                  rnd5 = Math.random() * nm5.length | 0;
                }

                if (i < 7) {
                    names = nm1[rnd] + nm2[rnd2] + nm3[rnd3] + nm2[rnd4] + nm5[rnd5] + ", " + nm16[rnd16];
                } else {
                  let rnd6 = Math.random() * nm4.length | 0;
                  let rnd7 = Math.random() * nm2.length | 0;
                  while (nm4[rnd6] === nm3[rnd3]) {
                    rnd6 = Math.random() * nm4.length | 0;
                  }
                  names = nm1[rnd] + nm2[rnd2] + nm3[rnd3] + nm2[rnd4] + nm4[rnd6] + nm2[rnd7] + nm5[rnd5] + ", " + nm16[rnd16];
                }
              }
            } break;
          }
        }

        resolve(dispatch("camelize", names));
      });
    },
    camelize(_, str) {
      return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word) {
        return word.toUpperCase();
      });
    },
    getEnvVariable(_, str) {
      return new Promise((resolve,reject) => {
        if (!process.env[str]) {
          reject('Variable not found')
          return
        }
        resolve(process.env[str])
      })
    }
  },
};
